export const LINK_KEYBOARD_SHORTCUT = 'mod+k';
export const LINK_TAG_NAME = 'a';
export const LINK_UPCASED_TYPE = 'Link';
